module.exports = __webpack_public_path__ + "static/media/back.d26f285b.svg";